import {useAppDispatch, useAppSelector} from "../../store/store";
import {useEffect, useState} from "react";
import {
  resetGenres,
  setFilterChanged,
  setGenres,
  setTemporaryCounter,
  setTemporaryGenres
} from "../../store/slices/filters.slice";
import styles from "./styles/FilterComponents.module.scss";
import Header from "../../components/header/Header";
import {ROUTES} from "../../constants/routes";
import GenresModule from "./components/GenresModule";
import FilterBar from "./components/FilterBar";
import Button from "../../components/shared/Button/Button";
import Footer from "../../components/footer/Footer";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import useWindowSize from "../../hooks/useWindowSize";
import {cleanUpFeedPage} from "../../store/slices/feed.slice";
import useFeed from "../../hooks/useFeed";
import GradientBackdrop from "../../components/shared/GradientBackdrop/GradientBackdrop";

const Filters = () => {
  const dispatch = useAppDispatch()
  const genres = useAppSelector((state: any) => state.filters.genres)
  const maxYear = useAppSelector((state: any) => state.filters.maxYear)

  const { windowSize } = useWindowSize();
  const isMobile = windowSize === "mobile";

  const navigate = useNavigate();
  const { t } = useTranslation();
  const { quickFilter, selectQuickFilter, onGenresApplied } = useFeed();

  const [genresValue, setGenresValue] = useState<any>([])

  useEffect(() => {
    setGenresValue(genres);
  }, [genres]);

  useEffect(() => {
    if (genresValue.length) {
      dispatch(setFilterChanged(true))
    } else {
      dispatch(setFilterChanged(false))
    }
    dispatch(setTemporaryCounter({genres: genresValue, period: [1980, maxYear]}))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [genresValue, dispatch]);

  const submitFilters = () => {
    dispatch(cleanUpFeedPage())
    dispatch(setGenres(genresValue))
    onGenresApplied(genresValue)

    const timeout =  setTimeout(() => {
      navigate(-1);
      clearTimeout(timeout);
    }, 300)
  }

  const setGenresValueHandler = (itemId: any) => {
    setGenresValue((currentIds: any) => {
      if (currentIds.includes(itemId)) {
        return currentIds.filter((currentId: any) => currentId !== itemId);
      } else {
        return [...currentIds, itemId];
      }
    });
    dispatch(setTemporaryGenres(itemId))
  }

  const clearGenresHandler = () => {
    setGenresValue([]);
    dispatch(resetGenres());
    onGenresApplied([]);
  }

  return (
    <div className={styles.filtersModalWrapper}>
      <Header source={ROUTES.FILTERS} clickHandler={() => {}} className={styles.headerWrapperFilters}/>
      <GradientBackdrop/>
      <div className={`${isMobile ? styles.contentWrapperMobile : styles.contentWrapper}`}>
        <FilterBar activeFilter={quickFilter} onSelect={selectQuickFilter} />
        <GenresModule
          fromPageFlag={false}
          isMobile={isMobile}
          className={styles.filtersPageGenres}
          titleKey="genre"
          setGenresValue={setGenresValueHandler}
          genres={genresValue}
          clearFiltersHandler={clearGenresHandler}
        />
        <div className={styles.btnsWrapper}>
          <Button submit={submitFilters} title={t('apply')} className={`${styles.submitButton} ${styles.filtersPageSubmitButton}`}/>
        </div>
      </div>
      <Footer source={ROUTES.FILTERS}/>
    </div>
  )
};

export default Filters;
